{
    "nuxtSiteConfig": {
        "description": "",
        "name": ""
    },
    "Bbk": {
        "global": {
            "here": "здесь",
            "edit": "редактировать",
            "back": "назад",
            "send": "отправить",
            "saveChanges": "сохранить изменения",
            "disabledCookies": "Браузер, работающий в режиме отключенных cookies, не позволяет нашему сайту работать должным образом. Пожалуйста, включите cookies или используйте другой браузер"
        },
        "badge": {
            "remove": "Удалить значок"
        },
        "breadcrumbs": {
            "homeText": "Главная страница"
        },
        "catalog": {
            "allProducts": "продукты",
            "page": "страница",
            "noProducts": "Нет продуктов",
            "goToHomepage": "Перейти на главную страницу",
            "show": "показать",
            "limit": "{quantity} продуктов"
        },
        "customer": {
            "newsletter": {
                "title": "Новостная рассылка",
                "heading": "В настоящее время у вас есть следующие услуги рассылки по электронной почте или SMS, заказанные на основании следующих заявлений:",
                "subscribed": "Ваша подписка успешно обновлена",
                "sms": "Для заказа услуги рассылки SMS",
                "cancel": "Для отмены подписки на услугу рассылки SMS",
                "fill": "заполните форму",
                "saveButton": "нажмите кнопку \"сохранить\"",
                "uncheck": "снимите отметку с соответствующего флажка",
                "saveChangesButton": "нажмите кнопку \"сохранить изменения\""
            },
            "address": {
                "heading": "управление платежным адресом",
                "add": "добавить адрес",
                "addNew": "добавить новый адрес",
                "addHeading": "добавление адреса",
                "save": "сохранить",
                "edit": "редактировать",
                "new": "новый адрес",
                "success": "адрес успешно сохранен",
                "person": "физическое лицо",
                "company": "компания",
                "removeQuestion": "Удалить адрес?",
                "remove": "удалить",
                "removeSuccess": "адрес успешно удален",
                "noAddress": "Нет адресов",
                "companyFullName": "полное название компании",
                "vatId": "ИНН",
                "name": "имя и фамилия",
                "address": "адрес",
                "postCode": "почтовый индекс",
                "city": "город",
                "phoneNumber": "номер телефона",
                "defaultShipping": "адрес доставки по умолчанию",
                "defaultBilling": "адрес для выставления счета по умолчанию"
            }
        },
        "wishlist": {
            "heading": "мой список желаний",
            "title": "список желаний",
            "addAllToCart": "Добавить все продукты в корзину",
            "placeholder": "комментарий",
            "editComment": "редактировать",
            "removeComment": "удалить",
            "saveComment": "сохранить комментарий",
            "addAll": "добавить все",
            "oneItemAddedToCart": "Товар добавлен в корзину",
            "allItemsAddedToCart": "Все товары добавлены в корзину",
            "toCart": "в корзину",
            "share": "поделиться",
            "shareTitle": "Поделиться списком желаний",
            "shareSubTitle": "Поделитесь своим списком желаний с друзьями",
            "shareEmail": "электронная почта",
            "shareMessage": "сообщение",
            "list": "список",
            "updateSuccess": "Список желаний успешно обновлен",
            "removeSuccess": "Товар удален из списка желаний"
        },
        "expandHtml": {
            "collapse": "свернуть",
            "expand": "развернуть"
        },
        "404": {
            "notFound": "Страница, которую вы ищете, не существует",
            "goHomePage": "Перейти на главную страницу"
        },
        "500": {
            "error": "Что-то пошло не так. Мы пытаемся решить проблему"
        },
        "filters": {
            "title": "фильтры и сортировка",
            "noFilters": "Нет фильтров",
            "clearAll": "сбросить все",
            "clear": "СБРОСИТЬ",
            "sorting": "СОРТИРОВКА",
            "apply": "ПРИМЕНИТЬ",
            "showMore": "показать больше",
            "showLess": "показать меньше",
            "price": "цена",
            "sort": {
                "positionASC": "позиция",
                "priceASC": "цена от низкой",
                "priceDESC": "цена от высокой",
                "popularityDESC": "популярность",
                "visit_counterDESC": "популярность",
                "newProducts": "новые продукты",
                "NEW_PRODUCTSDESC": "новые продукты"
            }
        },
        "gtm": {
            "inStorage": "На складе"
        },
        "page": {
            "product": {
                "notExist": "Продукт не существует"
            },
            "error": {
                "message": "Ошибка"
            }
        },
        "carousel": {
            "related": "Другие выбирали",
            "collection": "Другие из этой коллекции",
            "series": "Другие из этой серии"
        },
        "product": {
            "reservation": {
                "title": "Доступность и бронирование в салоне",
                "panelTitle": "Выберите салон и забронируйте",
                "panelHeading": "Введите местоположение и выберите салон",
                "searchPlaceholder": "местоположение",
                "notAvailable": "Товар недоступен для онлайн-продажи.",
                "available": "доступность",
                "city": "местоположение",
                "less": "показать меньше",
                "more": "показать больше",
                "take": "загрузить больше",
                "error": "К сожалению, у нас нет магазинов в этом месте. Пожалуйста, введите другой город.",
                "lastSelectedShopNoSupply": "К сожалению, товар недоступен в выбранном магазине. Пожалуйста, выберите другой магазин.",
                "openTimeWeek": "пн.-пт.",
                "openTimeSat": "сб.",
                "openTimeSun": "вс.",
                "notFound": "К сожалению, у нас нет магазинов по этому адресу. Введите другой город",
                "change": "Изменить салон",
                "switcherLabel": "показать только доступные",
                "confirm": "Подтверждение",
                "thankYou": "Спасибо за бронирование продукта",
                "successMessage": "Мы уведомим вас по SMS и электронной почте, когда наша команда завершит ваш заказ",
                "chooseShop": "Выберите салон",
                "productReservationDisabled": "Бронирование временно невозможно",
                "reservationNumber": "Номер вашего заказа:",
                "notification": {
                    "error": "Что-то пошло не так"
                },
                "availability": {
                    "0": "высокий",
                    "1": "низкий",
                    "2": "средний",
                    "3": "нет",
                    "4": "возможно нет"
                },
                "form": {
                    "firstName": "имя",
                    "lastName": "фамилия",
                    "phone": "телефон",
                    "email": "эл. почта",
                    "submit": "забронировать и оплатить в салоне"
                }
            },
            "card": {
                "addToCart": "добавить в корзину",
                "addToCartAll": "добавить все в корзину",
                "productDescription": "описание продукта",
                "shippingMethods": {
                    "title": "Доставка и оплата",
                    "courier": {
                        "title": "курьер",
                        "line1": "время доставки указано в корзине",
                        "line2": "заказ до 200 PLN – 15,00 PLN",
                        "line3": "заказ от 200 PLN - 0,00 PLN",
                        "line4": "онлайн / оплата при доставке"
                    },
                    "inPost": {
                        "title": "InPost",
                        "line1": "время доставки указано в корзине",
                        "line2": "заказ до 200 PLN - 9,99 PLN",
                        "line3": "заказ от 200 PLN - 0,00 PLN",
                        "line4": "оплата онлайн"
                    },
                    "collect": {
                        "title": "самовывоз в магазине",
                        "line1": "время доставки указано в корзине",
                        "line2": "только онлайн оплата",
                        "line3": "стоимость доставки 0 PLN"
                    },
                    "reservation": {
                        "title": "бронирование и самовывоз в магазине",
                        "line1": "забор в магазине в день бронирования",
                        "line2": "оплата на кассе в салоне",
                        "line3": "стоимость доставки 0 PLN"
                    }
                },
                "returns": {
                    "title": "Возвраты",
                    "content": "Вы осуществляете возврат за свой счет. Мы не принимаем наложенные платежи или личные возвраты.",
                    "contentMirakl": "Более подробную информацию о политике возврата этого продавца можно найти "
                },
                "details": {
                    "title": "Детали продукта",
                    "noInfo": "Нет дополнительной информации"
                },
                "unavailable": "Извините, продукт недоступен",
                "salesIndex": "каталожный номер",
                "logisticIndex": "код продукта"
            },
            "price": {
                "averagePrice": "самая низкая цена за последние 30 дней:",
                "averagePriceProduct": "самая низкая цена за 30 дней до скидки:",
                "regularPrice": "обычная цена:",
                "withTax": "С налогом"
            },
            "sellAndShip": "продано и доставлено: ",
            "sellAndShipShort": "продан: ",
            "legalText": "Продукт продается Продавцом Marketplace на торговой платформе Marketplace Home&You. Каждый Продавец Marketplace является предпринимателем. Договор купли-продажи заключается с Продавцом Marketplace. Все обязательства, связанные с договором купли-продажи, и ответственность за выполнение заказа несет Продавец Marketplace. Продавец Marketplace несет полную ответственность за соблюдение прав потребителей.",
            "amount": "штука",
            "from": "от",
            "chooseSize": "выберите другой размер",
            "otherSizeAvailable": "доступны другие размеры"
        },
        "search": {
            "result": "Результаты поиска для:",
            "noResult": "Нет результатов поиска"
        },
        "notification": {
            "show": "Показать",
            "close": "Закрыть",
            "addedToCart": "Добавлено в корзину",
            "addedToWishList": "Добавлено в список желаний",
            "continueShopping": "Продолжить покупки",
            "goToCard": "Перейти в корзину",
            "loginError": "Вы ввели неправильный логин/пароль или аккаунт не активен"
        },
        "form": {
            "login": {
                "title": "Войти",
                "titleRegister": "Зарегистрироваться",
                "apply": "Применить",
                "emailAddress": "адрес электронной почты",
                "password": "пароль",
                "forgotPassword": "забыли пароль?",
                "signIn": "Войти",
                "notHaveAccount": "у вас нет аккаунта?",
                "haveAccount": "у вас есть аккаунт?",
                "whyHaveAccount": "что вы получите, создав аккаунт?",
                "createAccount": "Создать аккаунт",
                "historyOrders": "история заказов",
                "fasterShopping": "быстрые покупки",
                "addressBook": "адресная книга",
                "favoritesList": "список избранного"
            },
            "register": {
                "title": "Форма регистрации",
                "firstName": "имя",
                "lastName": "фамилия",
                "phone": "телефон",
                "email": "электронная почта",
                "password": "пароль",
                "repeatPassword": "повторить пароль",
                "createAccount": "Создать аккаунт",
                "confirmation": "Подтверждение",
                "linkSent": "Ссылка для регистрации отправлена",
                "linkToConfirm": "Ссылка для подтверждения вашего аккаунта отправлена на указанный адрес",
                "dataAdministrator": "",
                "tooltip": {
                    "firstName": "Предоставление ваших данных необходимо для выполнения Договора управления аккаунтом, а в случае заказа вами",
                    "lastName": "Предоставление ваших данных необходимо для выполнения Договора управления аккаунтом.",
                    "email": "Предоставление ваших данных необходимо для проверки правильности указанного вами адреса электронной почты, а затем для выполнения Договора управления аккаунтом, а в случае заказа услуги рассылки по электронной почте, предоставление ваших данных необходимо для идентификации и выполнения договора оказания услуг рассылки по электронной почте и для целей связи.",
                    "phone": "Предоставление ваших данных необходимо для проверки правильности указанного вами телефонного номера, а затем для выполнения Договора управления аккаунтом, а если вы заказываете услугу рассылки SMS, предоставление ваших данных необходимо для целей идентификации и выполнения договора оказания услуг рассылки SMS и для целей связи.",
                    "password": "Предоставление ваших данных необходимо для защиты аккаунта."
                },
                "infoText": "Предоставление ваших данных необходимо для защиты аккаунта."
            },
            "validator": {
                "required": "это поле обязательно для заполнения",
                "email": "неправильный формат адреса",
                "confirm": "подтверждение пароля не совпадает",
                "matches": "пожалуйста, введите правильные данные",
                "containsUppercase": "должен содержать хотя бы одну заглавную букву",
                "containsLowercase": "должен содержать хотя бы одну строчную букву",
                "containsNumeric": "должен содержать хотя бы одну цифру",
                "postCode": "введите код в правильном формате 00-000",
                "telephone": "неправильный формат телефона",
                "nip": "проверьте правильность номера ИНН (10 цифр без дополнительных символов)"
            },
            "reset": {
                "send": "Отправить",
                "heading": "Забыли пароль?",
                "content": "Введите свой адрес электронной почты ниже, чтобы получить ссылку для сброса пароля.",
                "emailAddress": "электронная почта"
            },
            "create": {
                "apply": "Применить",
                "heading": "Новый пароль",
                "newPassword": "Новый пароль",
                "confirmPassword": "Повторите новый пароль",
                "passwordStrength": "сила пароля",
                "passwordStrong": "сильный",
                "passwordMedium": "средний",
                "passwordWeak": "слабый"
            },
            "confirmation": {
                "heading": "Подтверждение",
                "resetContent": "Если существует учетная запись, связанная с введенным адресом электронной почты, будет отправлено письмо со ссылкой для сброса пароля",
                "createContent": "Пароль успешно изменен"
            }
        },
        "cart": {
            "mini": {
                "goToCart": "перейти в корзину",
                "toPay": "к оплате",
                "resetContent": "Если существует учетная запись, будет отправлено сообщение со ссылкой для сброса пароля",
                "createContent": "Пароль успешно изменен"
            }
        },
        "newsletter": {
            "title": "Новостная рассылка",
            "form": {
                "title": "Новостная рассылка",
                "description": "Все мы знаем пословицу:<br/>чистый дом — чистый ум.",
                "join": "Хотите быть в курсе новостей? Присоединяйтесь к рассылке home&you",
                "benefits": "Узнайте о преимуществах подписки на нашу email или SMS рассылку:",
                "benefitsList": [
                    "СКИДКА 10% НА СЛЕДУЮЩУЮ ПОКУПКУ* В HOME&YOU",
                    "информация о последних продуктах и коллекциях",
                    "уведомления о предстоящих промоакциях и распродажах",
                    "вдохновение и советы по интерьеру"
                ],
                "titleInputs": "РЕГИСТРАЦИОННАЯ ФОРМА",
                "disclaimer": "*Одноразовый код на скидку действует только на непроданные товары бренда home&you; он не распространяется на покупку подарочных карт и не совмещается с другими акциями и скидками. Подробности в условиях обслуживания рассылки",
                "fillForm": "ЗАПОЛНИТЕ ФОРМУ, ЧТОБЫ НАСЛАЖДАТЬСЯ ВСЕМИ ПРЕИМУЩЕСТВАМИ",
                "questions": "Есть дополнительные вопросы? Напишите нам: <strong>{email}</strong>",
                "selectAll": "выбрать все",
                "defaultAgreement": "я принимаю условия соглашения.",
                "firstName": "имя",
                "email": "электронная почта",
                "phone": "телефон",
                "submit": "отправить",
                "agreementsNotSelected": "согласия не выбраны"
            },
            "remove": {
                "title": "Мы будем скучать",
                "description": "Ваш адрес электронной почты <strong>был удален из нашей базы данных</strong>."
            },
            "success": {
                "title": "<strong>Мы рады, что вы хотите оставаться с нами на связи</strong>",
                "paragraphEmail": "На ваш адрес электронной почты <strong>{email}</strong> мы отправим сообщение со ссылкой для активации",
                "paragraphSms": "На ваш номер телефона <strong>{phone}</strong> мы отправим сообщение со ссылкой для активации",
                "paragraphMix": "На ваш адрес электронной почты <strong>{email}</strong> и номер телефона <strong>{phone}</strong> мы отправим сообщение со ссылкой для активации",
                "paragraphTwo": "Если подтверждение не пришло в течение 15 минут, проверьте папку спам",
                "paragraphThree": "<strong>Если вы выбрали оба канала подписки, не забудьте подтвердить подписку на каждом из них.</strong>",
                "paragraphFour": "Если вы указали адрес электронной почты и <strong>не можете найти сообщение в своей почтовой ящике, проверьте папки: «СПАМ», «предложения» или подобные</strong>, в которые сообщение могло быть перенаправлено.\n\n",
                "paragraphFive":  "Если вы указали номер телефона и <strong>не получили сообщение SMS, убедитесь, что прошло 10 минут, и введите данные снова.</strong>",
                "paragraphSix": "*одноразовая скидка для использования на home-you.com в течение 30 дней с момента получения сообщения с кодом; подробности в правилах услуги рассылки",
                "promotion": "Нажмите на него, чтобы завершить процесс подписки на рассылку и получить <strong>скидку 10%* для новых подписчиков</strong>, а также быть в курсе новостей и рекламных акций!",
                "goToHomepage": "Перейти на главную страницу"
            },
            "confirm": {
                "title": "Спасибо, что вы с нами.",
                "paragraphOne": "На ваш адрес электронной почты мы отправим сообщение с <strong>кодом скидки 10%</strong>",
                "paragraphTwo": "Желаем удачных покупок.",
                "goToHomepage": "Перейти на главную страницу"
            }
        }
    }
}
